var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { MessageEnum } from '../models/message.enum';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { RemoveLabel, AddLabel, SetLabel, SetLabelsShown } from 'src/app/story/state/labels/story.labels.actions';
import { HotspotTypeEnum } from 'src/app/story/models/labels/hotspot.types.enum';
import { LabelPinType } from 'src/app/story/models/labels/label-pin-type.enum';
import { LabelThemeEnum } from 'src/app/story/models/labels/label-theme.enum';
import { omitBy, isNil } from 'lodash';
import { EventsEnum } from 'src/app/engine/models/events.enum';
/*
  TODO[AC]
  - cache user defined hotspot data
  - to be deprecated: should be maintained by client
*/
var dataCache = {};
function addHotspotData(id, hotspot) {
    if (hotspot.hasOwnProperty('data')) {
        hotspot[id] = hotspot.data;
    }
}
var ɵ0 = function (store) {
    var hotspotIdMap = HotspotManager.hotspotIdMap, createHotspotId = HotspotManager.createHotspotId;
    // side effect: ensure global id map is updated
    var labels = store.selectSnapshot(StoryLabelsState.getLabels);
    labels.forEach(function (label) {
        var labelId = label.id;
        var hotspotId = hotspotIdMap.get(labelId);
        if (typeof (hotspotId) === 'undefined') {
            createHotspotId(labelId);
        }
    });
    return hotspotIdMap;
}, ɵ1 = function (labelId) {
    // increament seed + add entry
    HotspotManager.hotspotSeedId++;
    HotspotManager.hotspotIdMap.set(labelId, HotspotManager.hotspotSeedId);
    return HotspotManager.hotspotSeedId;
}, ɵ2 = function (store, input, createEntry) {
    var getHotspotMap = HotspotManager.getHotspotMap, createHotspotId = HotspotManager.createHotspotId;
    var idMap = getHotspotMap(store);
    var hotspotId = idMap.get(input);
    // create entry if needed
    return createEntry && typeof (hotspotId) === 'undefined' ? createHotspotId(input) : hotspotId;
}, ɵ3 = function (store, input) {
    var idMap = HotspotManager.getHotspotMap(store);
    var foundPair = Array.from(idMap)
        .find(function (_a) {
        var _b = __read(_a, 2), lablId = _b[0], hotspotId = _b[1];
        return hotspotId === input;
    });
    return foundPair ? foundPair[0] : null;
};
/*
Notes:
- Hotspot IDs are numbers (int) instead of pass-through string IDs.
- Needs to be converted and tracked. label id (string) -> hotspot id (number) | hotspot id (number) -> label id (string)
- IDs are incremented on creation, querying etc.., to prevent collisions.
*/
var HotspotManager = {
    // incremental hotspot id
    hotspotSeedId: 0,
    // map of label id (string) -> hotspot id (number)
    hotspotIdMap: new Map(),
    getHotspotMap: ɵ0,
    createHotspotId: ɵ1,
    getHotspotIdByLabel: ɵ2,
    getLabelIdByHotspotId: ɵ3
};
function getLabels(store, chapterId) {
    var labels = store.selectSnapshot(StoryLabelsState.getLabels);
    return typeof (chapterId) !== 'undefined'
        ? labels.filter(function (label) { return label.chapterId === chapterId; }) // filter by chapter
        : labels; // all labels
}
function getLabelByHotspotId(store, hotspotId) {
    var labels = getLabels(store);
    var labelId = HotspotManager.getLabelIdByHotspotId(store, hotspotId);
    return labels.find(function (label) { return label.id === labelId; });
}
function getMarkerById(human, labelId) {
    return human.scene.markers.markers[labelId];
}
function convertHotspotToLabel(store, labelsService, hotspot) {
    var title = hotspot.title, objectId = hotspot.objectId, position = hotspot.position, direction = hotspot.direction, chapterScope = hotspot.chapterScope, type = hotspot.type;
    var chapters = store.selectSnapshot(StoryChaptersState.getStoryChapters);
    var chapter = store.selectSnapshot(StoryChaptersState.getSelectedChapter);
    var chapterIndex = store.selectSnapshot(StoryChaptersState.getSelectedChapterIndex);
    var targetChapterIndex = typeof (chapterScope) === 'number' ? chapterScope : chapterIndex;
    var targetChapter = chapters[targetChapterIndex] || chapter;
    // shown state
    var shown = hotspot.shown !== false;
    var labelShown = shown && !!title;
    var hotspotModel = {
        title: title,
        type: type ? type : HotspotTypeEnum.CircleLabel,
        objectId: objectId,
        pos: position ? fromXYZ(position) : null,
        dir: direction ? fromXYZ(direction) : null,
        shown: shown,
        symbol: '',
        className: '',
    };
    // convert to app style label
    var label = labelsService.deserializeHotspots({}, targetChapter, targetChapterIndex, hotspotModel);
    label.title = title;
    label.expandTag = true;
    label.flyTo = false;
    label.flyToTarget = null;
    label.occludable = true;
    label.pinGlow = false;
    label.pinType = LabelPinType.PlusMinus;
    // initial label shown state
    label.shown = shown;
    label.hideTag = !labelShown;
    label.hideWire = true;
    // set themes
    label.theme = LabelThemeEnum.StudioNext;
    // set pin type
    label.pinType = convertHotspotPinTypeToLabelPinType(type);
    // #TODO[AC]: cache client data
    addHotspotData(label.id, hotspot);
    return label;
}
function convertHotspotPinTypeToLabelPinType(hotspotType) {
    if (hotspotType === HotspotTypeEnum.CirclePlus) {
        return LabelPinType.Plus;
    }
    else if (hotspotType === HotspotTypeEnum.CircleMinus) {
        return LabelPinType.Minus;
    }
    else {
        return LabelPinType.Default;
    }
}
function convertLabelIdToHotspotId(store, labelId) {
    // get hotspot id
    return HotspotManager.getHotspotIdByLabel(store, labelId);
}
// utility to normalize string id properties to number id properties
function convertLabelResponseToHotspotResponse(store, input) {
    return __assign({}, input, { 
        // string id -> number id
        id: convertLabelIdToHotspotId(store, input.id) });
}
function convertLabelPositionToHotspotPosition(store, label) {
    var id = label.id, canvasPos = label.canvasPos;
    var x = canvasPos.x, y = canvasPos.y;
    return {
        id: convertLabelIdToHotspotId(store, id),
        canvasPosition: {
            0: x,
            1: y
        }
    };
}
function mergeLabelAndHotspot(hotspot, label) {
    var title = hotspot.title, objectId = hotspot.objectId, direction = hotspot.direction, position = hotspot.position, shown = hotspot.shown, type = hotspot.type;
    var extensions = __assign({}, label, { title: title,
        objectId: objectId,
        shown: shown, pos: position ? fromXYZ(position) : null, dir: direction ? fromXYZ(direction) : null, pinType: type ? convertHotspotPinTypeToLabelPinType(type) : null });
    // #TODO[AC]: cache client data
    addHotspotData(label.id, hotspot);
    return __assign({}, label, omitBy(extensions, isNil) // trim null extended properties
    );
}
function convertLabelToHotspot(human, store, chapters, label) {
    // get label props
    var id = label.id, chapterId = label.chapterId, title = label.title, objectId = label.objectId;
    // get chapter scope
    var chapterIndex = chapters.findIndex(function (chapter) { return chapterId === chapter.id; });
    // get mapped hotspot ID, else create
    var hotspotId = HotspotManager.getHotspotIdByLabel(store, id, true);
    var marker = getMarkerById(human, id);
    return {
        id: hotspotId,
        title: title,
        objectId: objectId,
        position: marker ? toXYZ(marker.pos) : null,
        direction: marker ? toXYZ(marker.dir) : null,
        canvasPosition: marker ? toXY(marker.canvasPos) : null,
        chapterScope: chapterIndex,
        type: label.pinType === LabelPinType.PlusMinus ? HotspotTypeEnum.CirclePlus : HotspotTypeEnum.Circle,
        shown: label.shown,
        data: dataCache[label.id]
    };
}
function convertLabelsToHotspots(human, store, labels) {
    var chapters = store.selectSnapshot(StoryChaptersState.getStoryChapters);
    return labels.map(function (label) { return convertLabelToHotspot(human, store, chapters, label); });
}
function toXYZ(input) {
    return { x: input[0], y: input[1], z: input[2] };
}
function fromXYZ(input) {
    return [input.x, input.y, input.z];
}
function toXY(input) {
    return { x: input[0], y: input[1] };
}
function getHotspotTypes() {
    return Object.values(HotspotTypeEnum)
        .map(function (type) { return "" + type; });
}
function createLabel(store, label) {
    // validate required fields for label creation
    if (label.objectId || label.pos) {
        store.dispatch(new AddLabel(label));
        return label;
    }
    else {
        return null;
    }
}
function updateLabel(store, label) {
    store.dispatch(new SetLabel(label));
    return label;
}
function destroyLabel(store, label) {
    store.dispatch(new RemoveLabel(label));
    return label;
}
function convertLabelFromHotspot(store, hotspot) {
    // get label
    var label = getLabelByHotspotId(store, hotspot.id);
    if (label) {
        // update label from hotspot
        return mergeLabelAndHotspot(hotspot, label);
    }
    else {
        return null;
    }
}
function setLabelsShown(store, labels, shown) {
    store.dispatch(new SetLabelsShown(labels, shown));
    return true;
}
function getLabelsFromHotspotFilter(store, hotspotFilter) {
    if (typeof (hotspotFilter) === 'number') {
        var label = getLabelByHotspotId(store, hotspotFilter);
        return label ? [label] : [];
    }
    else {
        return getLabels(store);
    }
}
export function getHotspotsEvents(human, store) {
    return [
        {
            eventName: EventsEnum.HotspotsEntered,
            mapFn: function (response) { return convertLabelResponseToHotspotResponse(store, response); }
        },
        {
            eventName: EventsEnum.HotspotsLeft,
            mapFn: function (response) { return convertLabelResponseToHotspotResponse(store, response); }
        },
        {
            eventName: EventsEnum.HotspotsPicked,
            mapFn: function (response) { return convertLabelResponseToHotspotResponse(store, response); }
        },
        {
            eventName: EventsEnum.HotspotsDisplayUpdated,
            mapFn: function (response) { return convertLabelResponseToHotspotResponse(store, response); }
        },
        {
            eventName: EventsEnum.HotspotsPositionUpdated,
            mapFn: function (response) { return convertLabelPositionToHotspotPosition(store, response); }
        }
    ];
}
export function getHotspotsProcedures(human, store, labelsService) {
    return [
        {
            procName: MessageEnum.HotspotsInfo,
            actionFn: function (hotspotId) {
                // if no param is sent by the client,
                // the RPC layer passes along an empty object, instead of undefined :/
                var sanitizedHotspotId = typeof hotspotId === 'number'
                    ? hotspotId
                    : undefined;
                // Mimic existing API:
                // if a hotspotId is requested, just return that hotspot.
                if (sanitizedHotspotId !== undefined) {
                    var label = getLabelByHotspotId(store, sanitizedHotspotId);
                    var hotspot = convertLabelsToHotspots(human, store, [label])[0];
                    return hotspot;
                }
                else {
                    // if no hotspotId is requested, return an array of hotspots.
                    var labels = getLabelsFromHotspotFilter(store, sanitizedHotspotId);
                    var hotspots = convertLabelsToHotspots(human, store, labels);
                    return hotspots;
                }
            }
        },
        {
            procName: MessageEnum.HotspotsTypes,
            mapFnIn: function () { return getHotspotTypes(); },
            actionFn: function (types) { return types; }
        },
        {
            procName: MessageEnum.HotspotsCreate,
            mapFnIn: function (hotspot) { return convertHotspotToLabel(store, labelsService, hotspot); },
            actionFn: function (label) { return createLabel(store, label); },
            mapFnOut: function (label) { return label ? convertLabelIdToHotspotId(store, label.id) : null; }
        },
        {
            procName: MessageEnum.HotspotsUpdate,
            mapFnIn: function (hotspot) { return convertLabelFromHotspot(store, hotspot); },
            actionFn: function (label) { return label ? updateLabel(store, label) : null; }
        },
        {
            procName: MessageEnum.HotspotsDestroy,
            mapFnIn: function (hotspotId) { return getLabelByHotspotId(store, hotspotId); },
            actionFn: function (label) { return label ? destroyLabel(store, label) : null; }
        },
        {
            procName: MessageEnum.HotspotsShow,
            mapFnIn: function (hotspotFilter) { return getLabelsFromHotspotFilter(store, hotspotFilter); },
            actionFn: function (labels) { return setLabelsShown(store, labels, true); }
        },
        {
            procName: MessageEnum.HotspotsHide,
            mapFnIn: function (hotspotFilter) { return getLabelsFromHotspotFilter(store, hotspotFilter); },
            actionFn: function (labels) { return setLabelsShown(store, labels, false); }
        }
    ];
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
